import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MAX_DESKTOP_GRID_WIDTH } from "constants/vp-sizes";
import DesktopHeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";

const HEADER_LOGO_HORIZONTAL_PADDING = `${DesktopHeaderConstants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;

export const componentStyles = css.global`
  .product-cards-side-by-side-text-and-asset-component {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;
    padding: ${`0 ${HEADER_LOGO_HORIZONTAL_PADDING}`};
    display: flex;
    gap: 48px;

    .product-card-component {
      flex: 1;
    }

    @media (max-width: ${`${MAX_DESKTOP_GRID_WIDTH}px`}) {
      gap: 36px;
      scale: 0.8;

      .product-card-component {
        padding-left: 48px;

        &.condensed-card {
          .card-top .product-details {
            padding-right: 12px;
            padding-left: 0;
          }
        }
      }
    }
  }
`;
